<template>
  <div id="app">
    <GlobalNotice @notice-closed="handleNoticeClosed" />
    <Navbar :class="{ 'navbar-with-notice': showNotice }" />
    <div class="app-view">
      <router-view/>
    </div>
    <FloatingControls />
    <Footer />
  </div>
</template>

<script>
import Navbar from '@/components/Navbar.vue'
import GlobalNotice from '@/components/GlobalNotice.vue'
import Footer from '@/components/Footer.vue'
import { mapState } from 'vuex'
import FloatingControls from '@/components/FloatingControls.vue'

export default {
  name: 'App',
  components: {
    Navbar,
    GlobalNotice,
    Footer,
    FloatingControls
  },
  data() {
    return {
      notice: {}
    }
  },

  computed: {
    ...mapState({
      notice: state => state.notice,
      showNotice: state => state.notice.showNotice
    })
  },
  
  created() {
    this.$store.dispatch('fetchNotice')
    // this.fetchNotice()
  },
  methods: {
    // fetchNotice() {
    //   // 模拟从后端获取通知
    //   this.notice = {
    //     id: '123',
    //     content: '这是一条测试通知',
    //     closeable: true
    //   }

    //   const noticeId = localStorage.getItem('currentNoticeId') 
    //   if (noticeId && noticeId === this.notice.id) {
    //     this.hasNotice = false
    //   } else {
    //     this.hasNotice = true
    //   }
    // },

    handleNoticeClosed() {
      this.hasNotice = false
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.app-view {
  padding-top: 100px;
}

.navbar-with-notice {
  margin-top: 40px !important;
}

h1, h2 {
  margin-bottom: 1rem;
}

img {
  max-width: 100%;
}
</style>
